<template>
    <div class="main-content" :style="mainContentViewHeight">
        <div class="edit-form">
            <el-tabs v-model="activeName" @tab-click="tableChange">
                <el-tab-pane label="查询语句配置" name="basicInfo">
                    <el-form
                            :model="dataForm"
                            :rules="dataRule"
                            v-show="isRouterAlive"
                            ref="dataForm"
                            @keyup.enter.native="dataFormSubmit()"
                            label-width="110px"
                    >
                        <el-form-item label="数据源：">
                            <span>{{ getDatasourceTitle() }}</span>
                        </el-form-item>
                        <el-form-item label="业务信息：">
                            <span>{{this.$route.params.title}}</span>
                        </el-form-item>
                        <el-form-item label="SQL语句：" prop="sqlClause">
                            <textarea
                                    v-model="dataForm.sqlClause"
                                    rows="20"
                                    placeholder="SQL语句"
                                    ref="myeditor"
                                    class="codesql"
                            ></textarea>
                        </el-form-item>
                        <el-form-item>
                            <span style="color: red;font-weight: bolder;">注意：查询过滤条件需要在sql中用&lt;filter/&gt;占位</span>
                            <el-button type="primary" style="float: right" size="small" @click="dataFormSubmit()">保存</el-button>
                        </el-form-item>
                    </el-form>

                </el-tab-pane>
                <el-tab-pane label="查询参数配置" name="searchArg">
                    <config-search-arg v-if="isRouterAlive" :formId.sync="formId"/>
                </el-tab-pane>
                <el-tab-pane label="字段映射" name="datasetField">
                    <config-dataset-field v-if="isRouterAlive"  :formId.sync="formId"/>
                </el-tab-pane>
                <el-tab-pane label="明细页面配置" name="detailPage">
                    <detail-list v-if="isRouterAlive"  :formId.sync="formId"/>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import ConfigDatasetField from "./list_config_dataset_field.vue";
    import ConfigSearchArg from "./list_config_search_arg.vue";
    import DetailList from "./list_config_dataset_detail_list"
    import 'codemirror/theme/ambiance.css'
    import 'codemirror/lib/codemirror.css'
    import 'codemirror/addon/hint/show-hint.css'
    import 'codemirror/addon/edit/matchbrackets'
    import 'codemirror/addon/selection/active-line'
    import 'codemirror/mode/sql/sql'
    import 'codemirror/addon/hint/sql-hint'
    import 'codemirror/addon/hint/show-hint'
    import CodeMirror from 'codemirror/lib/codemirror'
    import {aesEncrypt,aesDecrypt} from '@/utils'
    export default {
        props: ["mainContentViewHeight"],
        components: {ConfigDatasetField, ConfigSearchArg, DetailList},
        data() {
            return {
                activeName: "basicInfo",
                formId: "",
                sqlEditor:null,
                myeditor:null,
                dataForm: {
                    id: "",
                    datasourceId: "",
                    sqlClause: "",
                    hasMultiLine: false,
                },
                isRouterAlive: true,
                dataRule: {
                    datasourceId: [
                        {required: true, message: "请选择字段", trigger: "blur"},
                    ],
                    ruleCode: [
                        {required: true, message: "请选择数据源", trigger: "blur"},
                    ],
                },
            };
        },
        activated() {
            this.formId = this.$route.params.id;
          this.loadData();
        },
        created() {
          this.formId = this.$route.params.id;
          this.loadData();

        },
        methods: {
            getDatasourceTitle() {
                if (this.dataForm.attributes != undefined && this.dataForm.attributes.datasourceId != undefined) {
                    return this.dataForm.attributes.datasourceId;
                }
                return '无'
            },
            loadData() {
                this.initEditor()
                this.getBasicInfo()
                this.activeName = "basicInfo";
            },
            initEditor() {
              const mime = "text/x-mysql";
              var _that = this;
              if (!this.myeditor) {
                this.myeditor = this.$refs.myeditor;
              }
              if (this.sqlEditor){
                return
              }
              this.sqlEditor=CodeMirror.fromTextArea(this.myeditor,{
                value:this.dataForm.sqlClause||"",
                mode:mime,
                theme: "ambiance",
                indentWithTabs:true,
                tabSize:4,
                smartIndent:true,
                lineWrapping: true, // 文字过长时，是换行(wrap)还是滚动(scroll),默认是滚动
                lineNumbers:true,
                matchBrackets:true,
                autoRefresh: true,
                line:true,
                spellcheck:true,
                scrollbarStyle:null,
                hintOptions: {
                  completeSingle: false
                }
              });
              _that.sqlEditor.on('inputRead',()=>{
                _that.sqlEditor.showHint();
              })


            },
            tableChange(tab, event) {
                this.activeName = tab.name;
            },
            reload() {
                this.isRouterAlive = false
                this.$nextTick(() => (this.isRouterAlive = true))
            },
            getBasicInfo() {
                this.$http({
                    url: this.$http.adornUrl("/customform/getListSqlClauseInfo?id=" + this.formId),
                    method: "get",
                    baseURL: '',
                }).then(({data}) => {
                    if (data && data.code === "1") {
                        let dataForm = data.data||{};
                        dataForm.sqlClause = aesDecrypt(dataForm.sqlClause);
                        this.dataForm = dataForm;
                        this.sqlEditor.setValue(this.dataForm.sqlClause)
                    } else {
                        this.dataForm = {
                            id: "",
                            datasourceId: "",
                            sqlClause: "",
                            hasMultiLine: false,
                        };
                    }
                });
            },
            // 表单提交
            dataFormSubmit() {
                this.dataForm.hasMultiLine = false;
                let dataForm = JSON.parse(JSON.stringify(this.dataForm))
                if (dataForm.formId === undefined || dataForm.formId === '') {
                    dataForm.formId = this.formId
                }
                dataForm.sqlClause = aesEncrypt(this.sqlEditor.getValue()) ;

                this.$http({
                    url: this.$http.adornUrl("/customform/fromdataset/save"),
                    method: "post",
                    baseURL: '',
                    data: dataForm,
                }).then(({data}) => {
                    if (data && data.code === "1") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
        },

        watch: {
            $route(to, from) {
                if (window.location.href.indexOf("listconfig") != -1) {
                    this.formId = this.$route.params.id;
                    this.reload();
                }
            },
        },
    };
</script>
